const TeamGroupTeamInitialValues = (showData) => ({
  team_ids: showData?.data?.teams?.map((team) => team.id) || [],
});

export default TeamGroupTeamInitialValues;
